import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_MOEDAS } from 'store/modules/api/moedas.actions'

const lista = (state = null, { type, payload }) => (
  (type === API_LISTAR_MOEDAS.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_MOEDAS)

export default combineReducers({
  lista,
  isCarregandoLista,
})
